import type { GroupedProducts, Product } from '~/common/model/capabilities'

export const toGroupedProducts = (products: Product[]): GroupedProducts =>
  products.reduce((acc, product) => {
    const { group } = product
    if (!acc[group]) {
      acc[group] = []
    }
    acc[group].push(product)
    return acc
  }, {} as GroupedProducts)
